import React from 'react';
import { ButtonV2 } from '@withjoy/joykit';
import { AddCircle } from '@withjoy/joykit/icons';
import type { ContactInputFields, IframeContactInputFields } from '@apps/guest/contactCollector/shared/types';
import { newMember as guestNewMember } from '@apps/guest/contactCollector/ContactCollectorGuest.controller';
import { iframeContactInitialValue as iFrameNewMember } from '@apps/guest/contactCollector/shared/constants';

interface AddMemberProps
  extends Readonly<{
    push: (obj: ContactInputFields | IframeContactInputFields) => void;
    title: string;
    isIframeVersion: boolean;
  }> {}

export const AddMember: React.FC<AddMemberProps> = ({ push, title, isIframeVersion }) => (
  <ButtonV2
    startIcon={AddCircle}
    variant="ghost"
    paddingLeft={0}
    justifyContent="flex-start"
    margin="26px 0 10px"
    onClick={() => push(isIframeVersion ? iFrameNewMember : guestNewMember)}
  >
    {title}
  </ButtonV2>
);
